export const defaultLeaflet =
{
  url: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
  attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
  zoom: 5,
  center: [47.1, 1.434464],
  options: { scrollWheelZoom: true }
}
